// extracted by mini-css-extract-plugin
export default {"Root":"sign-in_Root__igByR","SwitchAccount":"sign-in_SwitchAccount__31YeW"};